var map = {
	"./Atari_2600.png": 5289,
	"./Microsoft_Xbox.png": 6707,
	"./Microsoft_Xbox_360.png": 9007,
	"./Microsoft_Xbox_One.png": 3374,
	"./NEC_PC_Engine.png": 3868,
	"./NEC_PC_Engine_CD.png": 5064,
	"./Nintendo_3DS.png": 9021,
	"./Nintendo_64.png": 2091,
	"./Nintendo_DS.png": 6850,
	"./Nintendo_Entertainment_System.png": 9539,
	"./Nintendo_Famicom_Disk_System.png": 2881,
	"./Nintendo_GameCube.png": 7516,
	"./Nintendo_Game_Boy.png": 5540,
	"./Nintendo_Game_Boy_Advance.png": 2507,
	"./Nintendo_Game_Boy_Color.png": 5792,
	"./Nintendo_Pokemon_Mini.png": 8006,
	"./Nintendo_Switch.png": 533,
	"./Nintendo_Switch_2.png": 9158,
	"./Nintendo_Virtual_Boy.png": 8631,
	"./Nintendo_Wii.png": 2496,
	"./Nintendo_Wii_U.png": 8604,
	"./SNK_Neo_Geo_CD.png": 9076,
	"./SNK_Neo_Geo_Pocket_Color.png": 5664,
	"./Sega_32X.png": 1015,
	"./Sega_CD.png": 5961,
	"./Sega_Dreamcast.png": 2774,
	"./Sega_Game_Gear.png": 6014,
	"./Sega_Genesis.png": 8836,
	"./Sega_Master_System.png": 3224,
	"./Sega_SG-1000.png": 7418,
	"./Sega_Saturn.png": 1402,
	"./Sony_PSP.png": 1350,
	"./Sony_Playstation.png": 8605,
	"./Sony_Playstation_2.png": 126,
	"./Sony_Playstation_3.png": 9623,
	"./Sony_Playstation_4.png": 7480,
	"./Sony_Playstation_5.png": 8609,
	"./Sony_Playstation_Vita.png": 7148,
	"./Soundtracks.png": 4298,
	"./Super_Nintendo_Entertainment_System.png": 7703,
	"./WonderSwan.png": 6597,
	"./WonderSwan_Color.png": 2361,
	"./default.png": 9608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7436;